module.exports = __webpack_public_path__ + "img/sayings@2x.929725d.webp";